<template>
    <b-card no-body class="rounded-0 w-100 h-100 pt-0" header-tag="header">
        <!-- En-tête de de la page -->
        <template #header>
            <b-row>
                <b-col cols="auto">
                    <!-- Gestion des logins de services -->
                    <h4 class="font-weight-semibold px-4 pb-0 m-0">{{ getTitle }}</h4>
                </b-col>
                <b-col/>
                <b-col cols="auto">
                    <b-button-toolbar key-nav :aria-label="$t('ToolbarButtons')">
                        <!-- Bouton d'ajout d'utilisateur -->
                        <!-- $t('AddUser') / Ajouter un utilisateur -->
                        <!-- :disabled="!$store.getters['CheckAction']('Add', undefined, Action)" -->
                        <b-button  v-if="!serviceLoginAddEdit" @click="serviceLogin = null; serviceLoginAddEdit = true" v-b-tooltip.noninteractive.hover :title="$t('AddServiceLogin')" :variant="Variant" class="btn-circle p-0 mx-1" >
                            <b-icon-plus/>
                        </b-button>
                    </b-button-toolbar>
                </b-col>
            </b-row>
        </template>
        
        <!-- Tableau d'affichage des logins de services -->
        <GenericTable v-if="!serviceLoginAddEdit" 
            :Headers="headers" 
            :Rows="serviceLoginList" 
            :EnablePagination="true" 
            :SelectionType="selectionTypeEnum.Simple" 
            :ShowCountRowNumber="true">
            <!-- Boutons d'action sur un utilisateur situé à droite des colonnes -->
            <template #menu-right="{ row }">
                <!--:disabled="!$store.getters['CheckAction']('Write', undefined, Action)"-->
                <b-button @click="addOrUpdateServiceLogin(row)" v-b-tooltip.noninteractive.hover :title="$t('Edit')" :variant="'outline-' + Variant"
                    class="btn-circle border-0 p-0">
                    <b-icon icon="pencil-fill" />
                </b-button>
            </template>
        </GenericTable>

        <!-- Formulaire d'ajout ou d'édition d'un login de service -->
        <ServiceLoginAddEdit v-else="serviceLoginAddEdit" :Variant="Variant"
            @CancelEvent="serviceLoginAddEdit = false; serviceLogin = null;" @SaveEvent="serviceLoginAddEdit = false; serviceLogin = null; loadServiceLogins();"
            :ServiceLoginForCompare="serviceLogin"
        />
    </b-card>
</template>
<script lang="ts">

import {Component, InjectReactive, Prop, ProvideReactive, Vue} from 'vue-property-decorator';

import GenericTable, { HeaderString, SelectionTypeEnum } from '../commons/Generics/GenericTable.vue';
import ITableHeader from '@/interfaces/ITableHeader';

/**Fichier de traduction local */
import locales from './locales/ServiceLogin.json'

import Dictionary from '@/types/Dictionary';
import { API_URL } from '@/App.settings';
import axios, { AxiosResponse } from 'axios';
import ServiceLoginAddEdit from './ServiceLogin/ServiceLoginAddEdit.vue';
import { ServiceLoginInformation } from './ServiceLogin/ServiceLoginInformation';

@Component({
    components: {
        GenericTable,
        ServiceLoginAddEdit
    },
    i18n: { messages : locales}
})
export default class ServiceLogin extends Vue {
    /** Pour avoir accès à l'énumérer dans la partie Vue. */
    private selectionTypeEnum = SelectionTypeEnum;   

    /** Variant du menu */
    @Prop({default: () => "quartary"})
    @ProvideReactive()
    private Variant!: string;

    /** Action utilisée pour la gestion des droits */
    @Prop()
    private Action!: string;

    /** Connection employé */
    private connectionRef: number = 57;

    /** Nom complet du login à éditer */
    private serviceLoginFullname: string = "";

    /** Mode d'ajout ou d'édition d'un login de service */
    private serviceLoginAddEdit: boolean = false;

    /** Formate le titre de la page en fonction des attributs de la vue (pour que celà soit plus visible qu'une ternaire de ternaire de ternaire ...) */
    private get getTitle(): string {
        if (this.serviceLogin) {
            if (this.serviceLogin.Id) {
                return this.$t('Edit') +' "' + this.serviceLoginFullname + '"';
            }
            else {
                return this.$t('NewLoginService').toString();
            }
        }
        else {
            return this.$t('LoginServicesManagement').toString();
        }
    }

    /** Liste des logins de services */
    private serviceLoginList: ServiceLoginInformation[] = [];

    /** Données du formulaire */
    private serviceLogin: ServiceLoginInformation;

    /** Liste des colonnes du tableau des logins de services */
    private headers: ITableHeader[] = [
        new HeaderString("Login", this.$t('Login').toString(), { HideMenu: false, ShowColumn: true, Sort: true }),
        new HeaderString("ConnectionName", this.$t('ConnectionName').toString(), { HideMenu: false, ShowColumn: true, Sort: true }),
    ];
    
    /** Charge la liste des logins de services */
    private async loadServiceLogins() {
        await this.$store.dispatch("ShowLoadingMask", this.$t("LoadingServiceLogins"));

        /** Nettoyage de la liste sans toucher à la référence du tableau */
        this.serviceLoginList.splice(0, this.serviceLoginList.length);
        
        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
        args["ConnectionRef"] = this.connectionRef;
            
        try{
            const response : AxiosResponse<any,any> = await axios.post(API_URL + "Supervision/ServiceLogins/GetServiceLogins", args)
            if(response && response.data){
                this.serviceLoginList = response.data;
                console.debug("this.serviceLoginList :", this.serviceLoginList);
            }
        }catch(err){
            console.error(err);
            this.$bvToast.toast(this.$t('AnErrorOccured').toString(), { 
                title: this.$t('Error').toString(),
                autoHideDelay: 10000,
                variant: "danger",
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-center"
            });
        }finally{
            await this.$store.dispatch("HideLoadingMask", {});
        }
    }

    /**
     * Prépare et affiche l'éditeur de login
     * @param serviceLogin 
     */
    private addOrUpdateServiceLogin(serviceLogin: ServiceLoginInformation){
        console.debug("addOrUpdateServiceLogin - serviceLogin :", serviceLogin);
        this.serviceLogin = serviceLogin;
        this.serviceLoginAddEdit = true;
    }
    
    /** Initialisation du composant */
    async created(){
        /** Chargement de la liste des logins de services */
        await this.loadServiceLogins();
    }
}
</script>

<style scoped>
</style>